import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-prototype',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './prototype.component.html',
  styleUrl: './prototype.component.scss'
})
export class PrototypeComponent {

}
